module.exports = __webpack_public_path__ + "static/media/PC_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI.926d0f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/agilidade/PC_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI.png
// module id = 72
// module chunks = 0